import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./styles.scss";
import ModalFrame from "../../../../toolkit/modalFrame";
import { handleRequestError } from "../../../../utils/helpers";
import { generateProductDiscounts } from "../../../actions/partners";
import ProductsBenefits from "../../annuitiesConfig/productsBenefits";

interface Props {
  isOpen: boolean;
  classifications: any[];
  partnerMembershipId: String;
  fitkidz: boolean;
  onOk: () => void;
  onCancel: () => void;
}

interface State {
  serverError: string | null;
}

class ModalAddProductsDiscounts extends React.Component<Props, State> {
  state = {
    serverError: null
  };
  onOkButton = async (productBenefit): Promise<boolean> => {
    const data = [productBenefit];

    // Limpiar error previo
    this.setState({ serverError: null });

    try {
      await generateProductDiscounts(this.props.partnerMembershipId, data);
      if (!!this.props.onOk) {
        this.props.onOk();
      }
      return true;
    } catch (error) {
      // Capturar y mostrar el error del servidor
      const errorMessage =
        (error &&
          error.response &&
          error.response.data &&
          error.response.data.message) ||
        "Error al crear el código de descuento";
      this.setState({ serverError: errorMessage });
      handleRequestError(error);
      return false;
    }
  };

  onCancelButton = () => {
    // Limpiar error al cancelar
    this.setState({ serverError: null });
    if (!!this.props.onCancel) {
      this.props.onCancel();
    }
  };

  onToggle = () => {
    // Limpiar error al cerrar con la X
    this.setState({ serverError: null });
    if (!!this.props.onCancel) {
      this.props.onCancel();
    }
  };

  render() {
    return (
      <ModalFrame
        title={`Creación de descuentos para productos`}
        isOpen={this.props.isOpen}
        toggle={this.onToggle}
        size="lg"
      >
        {this.state.serverError && (
          <div className="alert alert-danger" role="alert">
            {this.state.serverError}
          </div>
        )}
        <ProductsBenefits
          classifications={this.props.classifications || []}
          showCancelButton={true}
          fitkidz={this.props.fitkidz || false}
          addBenefit={this.onOkButton}
          cancelBenefit={this.onCancelButton}
        />
      </ModalFrame>
    );
  }
}

export default withStyles(s)(ModalAddProductsDiscounts);
